import { FaSpinner } from "react-icons/fa"

const LoadingScreen = ({text = "Cargando, por favor espera..."}) => {

  return (
    <div className="flex w-full h-full text-gray-700 items-center justify-center">
      <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
          <span>{text}</span>
          <FaSpinner className="animate-spin text-gray-500" />
      </div>
    </div>
  )
}

export default LoadingScreen